import React from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Box, Typography, Button } from '@mui/material';

const VerifyEmail = () => {
  const location = useLocation();
  const email = location.state?.email;

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5" gutterBottom>
          請驗證您的電子郵件
        </Typography>
        <Typography variant="body1" align="center" sx={{ mt: 2 }}>
          我們已經發送了一封驗證郵件到：
        </Typography>
        <Typography variant="body1" fontWeight="bold" sx={{ mt: 1 }}>
          {email}
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
          請檢查您的收件匣並點擊驗證連結以完成註冊。
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          如果您沒有收到郵件，請檢查垃圾郵件匣。
        </Typography>
        <Button
          variant="contained"
          sx={{ mt: 3 }}
          onClick={() => window.location.href = '/login'}
        >
          返回登入頁面
        </Button>
      </Box>
    </Container>
  );
};

export default VerifyEmail; 